import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="flex min-h-[70vh] items-center border-b border-ink-900 bg-white">
      <div className="container-wide grid items-end gap-10 py-20 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="flex items-center gap-3">
            <span className="h-2 w-2 bg-accent" />
            <span className="font-mono text-[11px] uppercase tracking-ultra text-ink-500">
              /// ERR 404 — File Not Found
            </span>
          </div>
          <h1 className="mt-8 font-display text-7xl font-black uppercase leading-[0.85] tracking-tighter text-ink-900 sm:text-9xl">
            <span className="text-outline">404</span>
            <br />
            <span className="text-accent">Missing.</span>
          </h1>
          <p className="mt-6 max-w-md font-mono text-base leading-relaxed text-ink-500">
            The page you're looking for has either been moved or never existed.
            Head back to the index.
          </p>
        </div>
        <div className="lg:col-span-4">
          <Link to="/" className="btn-primary" data-testid="404-back-home">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
}
